<template lang="html">
  <div class="container-fluid">
    <div class="container-fluid">
<table class="table table-hover table-sm col-md-11" ref="holdingtable" :data="goals">

  <thead>
    <div class = "row" slot="header">
      <h3 scope="col">
       Goals 
      </h3>
    </div>
    <tr>
      <th class="text-center" scope="col">Description</th>
      <th class="text-center" scope="col">Amount</th>
      <th class="text-center" scope="col">Goal Date</th>
      <th class="text-center" scope="col"></th>
    </tr>
  </thead>
  <tbody>
        <tr v-for="(goal, index) in goals" v-bind:key="index" >
          <td class="text-center" scope="row">
            {{goal.desc}}
          </td>
          <td class="text-center">
            {{goal.amount}}
          </td>
            <td class="text-center">
            {{goal.gdate}}
          </td>
          <td>
          <img @click.prevent="deletegoal(goal.id, index)" src="./icons/minus-circle.svg"></img>
          </td>
        </tr>
  </tbody>
  </table>
  </div>

<div class="form-row">
<div class="form-group col-md-3">
         <input type="text" class="form-control"placeholder="Description" v-model="desc"/>
        </div>

<div class="form-group col-md-3">
        <input  class="form-control" placeholder="Amount" type="number" v-model="amount"/>
        </div>
 
<div class="form-group col-md-3">
        <input  class="form-control" type="date" v-model="gdate"/>
        </div>
  
<div class="form-group col-md-3">
        <button type="button" class="btn btn-primary" @click="addgoal">Add Goal</button>
        </div>
  
</div>
  </div>
</template>

<script>
import db from './firebaseInit'
import firebase from 'firebase/app'
require('@firebase/auth');
require('@firebase/database');
require('@firebase/firestore');
require('@firebase/functions');
require('@firebase/messaging');
require('@firebase/storage');
require('@firebase/performance');

export default {
  name: 'goals',
  data () {
    return {
      goals: [],
      desc : null,
      amount : null,
      gdate: null
    }
  },
mounted (){  
    var userId
  var user = firebase.auth().currentUser;
   if (user != null) {
      userId = user.uid;
      } 
  db.collection('users').doc(userId).collection('goals').get().then
  (querySnapshot => {
    querySnapshot.forEach(doc => {
      //console.log(doc.data());
      const data = {
        'id' : doc.id,
        'desc' : doc.data().desc,
        'amount' : doc.data().amount,
        'gdate' : doc.data().gdate
      }
      this.goals.push(data)
      //console.log(data)
    })
  }
  )
  },
  methods: {
addgoal(){
  var user = firebase.auth().currentUser;
  var userId
   if (user != null) {
      userId = user.uid;
      } 
  db.collection('users').doc(userId).collection('goals').add({
 
    desc: this.desc,
    amount: parseFloat(this.amount),
    gdate: this.gdate
  }).then(ref => {
  //console.log('Added document with ID: ', ref.id);
})
},
  deletegoal: function(id,index){
  var user = firebase.auth().currentUser;
  var userId
   if (user != null) {
      userId = user.uid;
      } 
  db.collection('users').doc(userId).collection('goals').doc(id).delete().then(function() {
      console.log(index);

}).catch(function(error) {
  // Uh-oh, an error occurred!
});
this.goals.splice(index, 1);
}
  }


  
}
</script>